import { useAppDispatch } from "../../hooks/StoreHooks";
import { useProcessingRequest, useResponseValue } from "../../store/selectors/tableManagementSelector";
import { useServerSidePagination } from "../../hooks/PaginationHooks";
import { useEffect } from "react";
import { setResponseValue } from "../../store/reducers/tableManagementReducer";
import { AuditLogItem } from "../../types/auditLogTypes";
import { fetchPaginatedAuditLogsThunk } from "../../store/thunk/auditLogsThunk";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import { useTranslation } from "react-i18next";
import AuditLogsTable from "./AuditLogsTable/AuditLogsTable";
import { CircularIndeterminate } from "../../components/common/CircularIndeterminate";

export default function AuditLogs() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const processingRequest = useProcessingRequest();
  const responseValue = useResponseValue();

  const paginatedData = useServerSidePagination<AuditLogItem>(
    async (paginationParameters) => {
      const resultAction = await dispatch(fetchPaginatedAuditLogsThunk(paginationParameters));
      
      if (fetchPaginatedAuditLogsThunk.fulfilled.match(resultAction)) {
        return resultAction.payload;
      } else {
        return { items: [], totalCount: 0 };
      }
    },
    [],
    "desc",
    "timestamp"
  );

  useEffect(() => {
    if (responseValue.includes("fulfilled")) {
      paginatedData.updateTableItems();
      dispatch(setResponseValue(""))
    }
  }, [dispatch, paginatedData, responseValue]);

  return (
    <>
      <PageTitle
        title={t("auditLogsPage.title")}
      />
      <AuditLogsTable
         data={paginatedData}
      />
      <CircularIndeterminate processingRequest={processingRequest} />
    </>
  );
};
